import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import { CircularProgress, Fade } from "components/controls/widget";
import classNames from "classnames";


export interface LoadingInfo {
    loading?: boolean;
    hasError?: boolean;
    error?: string;
}


export interface LoadingProps {
    loading: boolean;
    delay?: number;
    centered?: boolean;
    color?: 'primary' | 'secondary';
}

declare type Props = LoadingProps & WithStyles<typeof styles>;

class Loading extends React.PureComponent<Props> {

    render() {

        const { classes, loading, delay, color, centered } = this.props;

        const spinerClass = classNames({
            [classes.spinner]: true,
            [classes.spinerPrimary]: color === 'primary',
            [classes.centered]: centered === true,
        });

        return loading && <div className={classes.root}>
            <Fade in={loading} style={{ transitionDelay: loading ? `${delay || 500}ms` : '0ms', }} unmountOnExit>
                <CircularProgress size={24} thickness={4} disableShrink variant="indeterminate" className={spinerClass} />
            </Fade>
        </div>;
    }
}

const styles = (theme: Theme) => {

    return createStyles({

        root: {
            padding: theme.spacing.unit,
            position: 'relative',
            width: '100%',
            zIndex: 1000,
        },

        centered: {
            height: '100%',
        },

        spinner: {
            color: theme.palette.secondary.main,
            left: '50%',
            top: '50%',
            position: 'relative',
            //position: 'absolute',
            animationDuration: '550ms',
        },

        spinerPrimary: {
            color: theme.palette.primary.main,
        }

    })
}

export default withStyles(styles)(Loading);
